import { useTranslations } from "@zapier/i18n";
import {
  BetaCardBody,
  BetaCardRootContainer,
  Button,
  Heading,
  HeadingLevel,
  Link,
  Text,
  Typography,
} from "@zapier/design-system";
import { Icon } from "@zapier/zinnia-icons";
import styles from "./FirstConnectionEmptyState.module.css";
import illustration from "./connections-first-connection.svg";

// Content design has flagged this may move to a different article - update
// the link if it starts pointing elsewhere.
const MANAGED_CONNECTIONS_HELP_URL =
  "https://help.zapier.com/hc/en-us/articles/44795921426317-Manage-app-connections-with-managed-apps#h_managed_apps_vs_allowed_domains";

interface Props {
  onAddManagedConnection: () => void;
}

// EmptyState's size options don't fit this wide-illustration/side-by-side-
// button layout, so this bridges Card/Heading/Text/Button instead.
export function FirstConnectionEmptyState({ onAddManagedConnection }: Props) {
  const t = useTranslations("connections-first-connection-empty-state");

  return (
    <BetaCardRootContainer
      variant="elevated"
      data-custom-component="connections::first-connection-empty-state"
    >
      <BetaCardBody>
        <div className={styles.root}>
          {/* eslint-disable-next-line next/no-img-element -- static asset, no Next.js loader needed */}
          <img src={illustration.src} alt="" />
          <div className={styles.copy}>
            <HeadingLevel>
              <Heading style={Typography.SectionHeader}>
                {t("headings.title")}
              </Heading>
            </HeadingLevel>
            <Text type="Body1Multiline" tag="p">
              {t("messages.paragraph")}
            </Text>
          </div>
          <div className={styles.actions}>
            <Button
              variant="secondary"
              size="medium"
              iconPosition="start"
              onPress={onAddManagedConnection}
            >
              <Icon name="formAdd" aria-hidden={true} />
              {t("buttons.add-managed-connection")}
            </Button>
            <Link
              href={MANAGED_CONNECTIONS_HELP_URL}
              target="_blank"
              variant="tertiary"
              size="medium"
            >
              {t("buttons.learn-about-managed-connections")}
            </Link>
          </div>
        </div>
      </BetaCardBody>
    </BetaCardRootContainer>
  );
}
